import React from "react";
import Users  from "../modules/Users/Users";
export default function UsersPage() {
  return <Users />;
}
